/** The browser follows the original public download URL; this only adds status and analytics. */
(() => {
  if (customElements.get('maison-download')) return;

  customElements.define('maison-download', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      // Preserve the recovery page's robots directives in the document head after rendering.
      const robots = this.closest('.shopify-section')?.querySelector('[data-maison-download-robots]');
      if (robots) {
        const previous = document.head.querySelector('[data-maison-download-robots]');
        if (previous) previous.replaceWith(robots);
        else document.head.append(robots);
      }
      this.querySelector('[data-download]')?.addEventListener('click', () => {
        const status = this.querySelector('[data-status]');
        if (status) status.hidden = false;
        window.dataLayer ||= [];
        if (typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'cinegrams_preset_download', product: 'Vintage Film LR Presets' });
        }
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
})();
